import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import { connect } from 'react-redux';
import { Button, Form, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { setSuccessMessage } from '../../modules/App/ErrorsActions';
import moment from 'moment';

import Header from '../../components/Header/Header';
import Switch from '../../components/Switch/Switch';
import DashboardActivities from '../Dashboards/components/DashboardAcivities';

import { handleError, saveStream, listAll } from './ReportActions';
import { listAll as getDashboards } from '../../components/DashboardSelector/DashboardSelectorActions';
import throttle from '../../util/throttle';
import { PAGES, trackPageView } from '../../util/mixpanel';


import linkIcon from '../../assets/img/link.svg';
import openInNewIcon from '../../assets/img/open-in-new.svg';

import './ReportConfig.scss';

class ReportConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selected: [],
      name: '',
      excludeWeekends: 0,
      workStart: '09:00',
      workEnd: '17:00'
    };

    this.handleTimeChange = throttle(this._handleTimeChange, 1000, this);
  }

  componentDidMount() {   
    if (!this.props.dashboards.length) {
      this.props.getDashboards();
    }
    if (!this.props.streams.length) {
      this.props.getStreams();
    }

    if (!!this.props.settings && this.props.params.id && this.props.params.id === this.props.settings._id) {
      this.setSettingsState(this.props.settings);
    }

    trackPageView(PAGES.CONFIGURE);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.settings, this.props.settings)) {
      this.setSettingsState(this.props.settings);
    }
    if (prevProps.streams != this.props.streams) {
      const stream = this.props.streams.find(d => d._id == this.props.params.id) || {};
      this.setSettingsState(stream);
    }
  }

  redirect(id) {    
    this.props.router.push(`/report/${id}`);
  }

  setSettingsState(settings) {
    this.setState({
      streamId: settings._id,
      isNew: settings.isNew,
      name: settings.name,
      url: settings.shortUrl,
      selected: settings.selectedDashboards || [],
      excludeWeekends: settings.excludeWeekends || 0,
      workStart: settings.workStart || '09:00',
      workEnd: settings.workEnd || '17:00'
    });
  }
  
  handleExcludeWeekendSwitch = () => {
    this.setState({ excludeWeekends: this.state.excludeWeekends === 0 ? 1 : 0 });
  }

  _handleTimeChange = (name, e) => {
    if (!e) {
      return false;
    }

    const newTime = new moment(e, 'HH:mm');

    switch (name) {
      case 'workStart': {
        const endTime = new moment(this.state.workEnd, 'HH:mm');
        if (newTime.isSame(endTime, 'minute')) {
          this.props.handleError(`Starting time should not be equal to Finishing time`);
          return false;
        }
        if (newTime.isAfter(endTime, 'minute')) {
          this.props.handleError(`Starting time should be before Finishing time`);
          return false;
        }
        this.setState({ workStart: e });
        break;
      }
      case 'workEnd': {
        const startTime = new moment(this.state.workStart, 'HH:mm');
        if (newTime.isSame(startTime, 'minute')) {
          this.props.handleError(`Finishing time should not be equal to Starting time`);
          return false;
        }
        if (newTime.isBefore(startTime, 'minute')) {
          this.props.handleError(`Finishing time should be after Starting time`);
          return false;
        }
        this.setState({ workEnd: e });
        break;
      }
    }
  };
  preventSubmit = event => {
    event.preventDefault();   
  };

  handleSubmit = event => {
    event.preventDefault();
    if (!this.state.name) {
      this.props.handleError('Name should be filled in');
      return false;
    }
    if (!this.state.selected.length) {
      this.props.handleError('Please select at least one dashboard');
      return false;
    }

    const data = {
      streamId: this.state.streamId,
      isNew: this.state.isNew,
      name: this.state.name,
      selectedDashboards: this.state.selected,
      excludeWeekends: +this.state.excludeWeekends,
      workStart: this.state.workStart,
      workEnd: this.state.workEnd
    };

    this.props.setSettings(data).then(res => this.redirect(res._id));
  };

  handleCopied = () => {
    this.props.setSuccess('URL copied');
  };

  handleChange = e => {
    let selected = [...this.state.selected];

    if (!e.checked) {
      let index = selected.indexOf(e.name);
      if (index === -1) {
        index = _.indexOf(selected, e.value);
      }

      selected.splice(index, 1);
    } else {
      selected.push(e.name);
    }

    selected = _.uniq(selected);

    this.setState({ selected });
  };

  renderWallboardUrl() {
    const { wallboardUrl } = this.props.settings;
    if (wallboardUrl) {
      return (
        <Form.Group controlId="wallboard-url" className='display_url_input'>
          <Form.Label>Wallboard URL</Form.Label>
          <div>
            <Form.Control type="text" name="wallboard-url" value={wallboardUrl} readOnly />
            <CopyToClipboard text={wallboardUrl} onCopy={this.handleCopied}>
              <a className='btn btn-md btn-secondary'>
                <img src={linkIcon} alt="#" />
                Copy
              </a>
            </CopyToClipboard>
            <a href={wallboardUrl} target="_blank" className='btn btn-md btn-primary'>
              <img src={openInNewIcon} alt="#" />
              Open
            </a>
          </div>
        </Form.Group>
      );
    }
  }

  render() {
    const { url, selected, name, excludeWeekends } = this.state;
    const backUrl = selected._id ? `/report/${selected._id}`: '/report';
    return [
      <Helmet key="1">
        <title>{pageTitle('Value Stream')}</title>
      </Helmet>,
      <Header key="2" title="" showHome={true} hideReport={true} />,
      <div key="3" className='bg_dashboard config_content'>
        <div className="container">
         
          <Form className='form_content' onSubmit={this.preventSubmit}>
            {this.props.location && this.props.location.query && this.props.location.query['fromPortfolio'] == 'true' &&
              <div className="time_spent_box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M19.5276 21.2795C21.0676 21.2795 22.0276 19.6095 21.2576 18.2795L13.7276 5.26947C12.9576 3.93947 11.0376 3.93947 10.2676 5.26947L2.73756 18.2795C1.96756 19.6095 2.92756 21.2795 4.46756 21.2795H19.5276ZM11.9976 14.2795C11.4476 14.2795 10.9976 13.8295 10.9976 13.2795V11.2795C10.9976 10.7295 11.4476 10.2795 11.9976 10.2795C12.5476 10.2795 12.9976 10.7295 12.9976 11.2795V13.2795C12.9976 13.8295 12.5476 14.2795 11.9976 14.2795ZM10.9976 16.2795V18.2795H12.9976V16.2795H10.9976Z" fill="#B37100"/>
                  </svg>
                  <span>You need at least two value streams to create a Portfolio. Please create a new value stream before proceeding.</span>
                </div>             
            }
            <div className='btn-action'>
                {this.props.streams && this.props.streams.length > 0 &&
                  <Link to={backUrl} className='btn btn-secondary btn-prev'>
                    Back
                  </Link>
                }
                <Button variant="primary" type="submit" onClick={this.handleSubmit}>
                  {this.props.isLoading ? 'Loading...' : this.props.isNew ? 'Create value stream': 'Save changes'}
                </Button>
            </div>
                       
            <div className="form-row-flex">
              <Form.Group controlId="name" className='display_url_input name-field'>
                <Form.Label>Value stream name</Form.Label>
                <div>
                  <Form.Control type="text" name="stream-name" value={name} onChange={e => this.setState({ name: e.target.value })} className='name_input' />                
                </div>
              </Form.Group>
              {url && (
                <Form.Group controlId="wallboard-url" className='display_url_input wallboard-field'>
                  <Form.Label>Wallboard URL</Form.Label>
                  <div>
                    <Form.Control type="text" name="wallboard-url" value={this.props.settings && this.props.settings.wallboardUrl} readOnly />
                    <CopyToClipboard text={this.props.settings && this.props.settings.wallboardUrl} onCopy={this.handleCopied}>
                      <a className='btn btn-md btn-secondary'>
                        <img src={linkIcon} alt="#" />
                        Copy
                      </a>
                    </CopyToClipboard>
                    <a href={this.props.settings && this.props.settings.wallboardUrl} target="_blank" className='btn btn-md btn-primary'>
                      <img src={openInNewIcon} alt="#" />
                      Open
                    </a>
                  </div>
                </Form.Group>
              )}
              <Form.Group controlId="dashboards" className='switch_content exclude-weekends-field'>
                <Switch
                  id="none"
                  className="switch_box_right_label"
                  name="excludeWeekends"
                  label="Exclude weekends"
                  checked={!!excludeWeekends}
                  onChange={this.handleExcludeWeekendSwitch}
                />
              </Form.Group>
            </div>

            <Form.Group controlId="dashboards" >             
              <DashboardActivities selectable handleChange={this.handleChange} selected={selected}></DashboardActivities>
            </Form.Group>
          </Form>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err, { log: false })),
    setSuccess: msg => dispatch(setSuccessMessage(msg, { toastId: 'url_success' })),
    getDashboards: () => dispatch(getDashboards()),    
    setSettings: data => dispatch(saveStream(data)),
    getStreams: () => dispatch(listAll()),
  };
};

const mapStateToProps = state => {
  return {
    dashboards: state.dashboards.list,
    isLoading: state.report.isLoading,
    settings: state.report.selectedStream,
    streams: state.report.streams,
    user: state.auth.user
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportConfig);
